import { CRS, extend, Transformation } from "leaflet";

export default new (function () {
  const customCRS = {
    transformation: new Transformation(1, 0, 1, 0)
  };
  return extend({}, CRS.Simple, customCRS);
})();
